function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * シーケンスグループ　モデル
 */
var SequenceGroupInstanceModel =
/**
 * コンストラクタ
 *
 * @param groupNo グループ番号
 * @param no 番号
 */
function SequenceGroupInstanceModel(groupNo, groupName) {
  _classCallCheck(this, SequenceGroupInstanceModel);

  this.GroupNo = groupNo;
  this.GroupName = groupName;
  this.Sequences = [];
  this.hasChange = false;
};

export { SequenceGroupInstanceModel as default };